<template>
  <div class="main_view">
    <div class="form_view">
      <el-card>
        <el-form  ref="form" :rules="rules"  :model="form">
          <el-row>
            <el-col :span="24" class="title_cummins">
              <img :src="CumminsLogoTouMing" alt="Cummins" class="logo">
              <span class="title_span">康明斯授权经销商查询</span>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="name" style="display: flex;flex-direction: column">
                <template slot="label">
                  <span class="form_title">经销商名称</span>
                  <span style="color: red">*(请确保名称准确)</span>
                </template>
                <el-input v-model="form.name" placeholder="请输入经销商名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item  prop="phone"  style="display: flex;flex-direction: column">
                <template slot="label">
                  <span class="form_title">手机号</span>
                  <span style="color: red">*</span>
                </template>
                <el-input v-model="form.phone" placeholder="请输入您的手机号以便获取验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="captch" style="display: flex;flex-direction: column">
                <template slot="label">
                  <span class="form_title">验证码</span>
                  <span style="color: red">*</span>
                </template>
                <div style="display: flex; align-items: center;">
                  <el-input class="input_captch" v-model="form.captch" placeholder="请输入验证码" ></el-input>
                  <el-button type="danger" class="cap_desc"  @click="getCaptcha" :disabled="haveCaptch">{{capDesc}}</el-button>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="isAgree">
                <el-col :span="2">
                  <el-checkbox-group v-model="form.isAgree">
                    <el-checkbox name="type"></el-checkbox>
                  </el-checkbox-group>
                </el-col>
                <el-col :span="22" class="yinsi">勾选代表您同意《<el-link style="color: red" :underline="false" @click="goToYinsi">隐私协议</el-link>》</el-col>
              </el-form-item>
            </el-col>

          </el-row>
          <el-form-item class="last_btn">
            <el-button  el-button type="danger" round @click="onSubmit('form')" class="select_btn">立即查询</el-button>
          </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible" style="margin-top: 15vh"  destroy-on-close :width=diaWidth>
          <solide ref="slideblock" @success="onSuccess" @again="onAgain" @fulfilled="onFulfilled"
                  @fail="onFail" @refresh="onRefresh" :slider-text="text" :imgs="imgs" :accuracy="accuracy" :w="w">
<!--                  @fail="onFail" @refresh="onRefresh" :slider-text="text" :imgs="imgs" :accuracy="accuracy" :w="w">-->
          </solide>
        </el-dialog>
      </el-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CumminsLogo from '../assets/img.png'
import CumminsLogoBlack from '../assets/CumminsLogo-black.png'
import CumminsLogoTouMing from '../assets/CumminsLogoTouMing.png'
import solide from "../tools/solide.vue"
import img0 from "../assets/1.jpg";
import img1 from "../assets/2.jpg";
import img2 from "../assets/3.jpg";
import img3 from "../assets/4.jpg";
import img4 from "../assets/5.jpg";
import img5 from "../assets/6.jpg";
import img6 from "../assets/7.jpg";
import img7 from "../assets/8.jpg";
import img8 from "../assets/9.jpg";
import img9 from "../assets/10.jpg";

export default {
  name: 'Index',
  components: {
    solide
  },
  data () {
    var checkPhone = (rule, value, callback) => {
      // 手机号验证
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3456789]\d{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      onDialogClose:false,
      diaWidth:"400px",
      dialogVisible: false,
      CumminsLogo,
      CumminsLogoBlack,
      CumminsLogoTouMing,
      capDesc: "获取验证码",
      haveCaptch: true,
      remainingTime: 60,
      w:400,
      form: {
        name: "",
        phone: "",
        captch: "",
        isAgree: []
      },
      rules: {
        name: [
          { required: true, message: '请输入经销商名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        captch: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        isAgree:  [
          { type: 'array', required: true, message: '请勾选《隐私协定》', trigger: 'change' }
        ]
      },
      msg: '',
      text: '向右滑动->',
      imgs: [
        img0,
        img1,
        img2,
        img3,
        img4,
        img5,
        img6,
        img7,
        img8,
        img9
      ],
      loginBtn: false,
      accuracy: 5, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      formLabelAlign: {},
    }
  },
  methods:{
    handleResize() {
      // console.log(window.innerWidth,"屏幕宽度") ;
      // console.log(window.innerHeight,"屏幕高度");
    },
    handleClose(done) {
    },
    goToYinsi(){
      this.$router.push("yinsi")
    },
    getCaptcha(){
      this.dialogVisible=true

    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.capDesc=this.remainingTime+" s "
          this.haveCaptch=true
          this.remainingTime--;
        } else {
          this.capDesc="获取验证码"
          // this.haveCaptch=false
          clearInterval(this.timer);// 清除计时器
          //判断手机号是否发生更改
          const phoneRegex = /^1[3-9]\d{9}$/;
          this.haveCaptch = !phoneRegex.test(this.form.phone);
          this.remainingTime=60
        }
      }, 1000); // 每秒更新一次
    },
    onSubmit(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          //验证验证码是否正确
          axios.post('https://cma-svc-prod.cummins.com.cn/portal/common/verificationCodeForOutSystem', {
          // axios.post('/portal/common/verificationCodeForOutSystem', {
            "phoneNumber":this.form.phone,
            "messageType":10,
            "code":this.form.captch
          },{
            headers: {
              'Content-Type': 'application/json',
              "Accept":"*/*"
            }})
            .then(response => {
              // console.log(response,"wwwwwwwwwwwwwww")
              if(response.status===200){
                //调用获取salesforce认证的方法
                if(response.data.status===0){
                  let obj= {
                    "phoneNumber":this.form.phone,
                    "dealerName":this.form.name,
                    "equipment":"portal网页端"
                  }
                  this.$store.commit('setDealerInfo', obj);
                  this.$router.push({path:"/dealerInfo"})
                }else{
                  this.$message.error("验证码错误，请重试")
                }

              }
            })
            .catch(error => {
              console.error('There was an error!', error);
            });

        } else {
          return false;
        }
      });

    },
    //滑动校验部分
    onSuccess () {

      this.dialogVisible=false
      this.startTimer()
      axios.post('https://cma-svc-prod.cummins.com.cn/portal/common/sendSMSForOutSystem', {
      // axios.post('/portal/common/sendSMSForOutSystem', {
        // "phone":this.form.phone,
        "phone":this.form.phone,
        "messageType":10
      },{
        headers: {
          'Content-Type': 'application/json',
          "Accept":"*/*"
        }})
        .then(response => {
          // console.log(response.data);
        })
        .catch(error => {
          this.$message.error('发送失败!')
        });
      // this.msg = `login success, 耗时${(times / 1000).toFixed(1)}s`;
    },
    onFail () {
      this.$message.error('验证不通过!',1000);
      console.log('验证不通过');
      this.msg = ''
    },
    onRefresh () {
      console.log('点击了刷新小图标');
      this.msg = ''
    },
    onFulfilled () {
      console.log('刷新成功啦！');
    },
    onAgain () {
      console.log('检测到非人为操作的哦！');
      this.msg = 'try again';
      // 刷新
      this.handleClick();
    },
    handleClick () {
      this.$refs.slideblock.reset();
      this.msg = ''
    },

  },
  mounted() {
    // console.log( window.innerWidth,"设备宽度")
    let screenWidth=window.innerWidth
    if(screenWidth<400){
      this.diaWidth=screenWidth+"PX"
      this.w=screenWidth-30
    }else{
      this.w=400-30
      this.diaWidth="400PX"
    }
  },
  // created() {
  //   console.log(window.innerWidth,"原始屏幕宽度") ;
  //   console.log(window.innerHeight,"原始屏幕高度");
  //   window.addEventListener('resize', this.handleResize);
  // },

  watch:{
    'form.phone': function(newVal) {
      // 正则表达式用于验证手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/;
      if(this.capDesc==="获取验证码"){
        this.haveCaptch = !phoneRegex.test(newVal);
      }

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo{
  width: 70PX;
}
.main_view{
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
}
.form_view{
  margin: auto;
  width: 500PX;
}
/deep/ label{
  margin-bottom: 0PX;
}
/deep/ .el-form-item__label{
  text-align:left !important;
}
/deep/ .el-form-item{
  margin-bottom: 10PX !important;
}
/deep/ .el-card{
  background-color:rgb(242,242,242);
}
.el-card__body, /deep/.el-main{
  padding: 30PX !important;
}
.title_span{
  padding-left: 5PX;
  font-size: 20PX;
  font-weight: bold;
}
.yinsi{
  line-height: 43PX;
  text-align: left;
}
.last_opt{
  margin-bottom: 10PX;
}
.select_btn{
  width: 100%;
}
.input_captch{
  flex: 1;
  padding-right: 10PX;
}
.cap_desc{
  width: 120PX;
}
.form_title{
  color: black;
  font-size: 16PX;
}
.last_btn{
  margin-top: 10PX;
}
.title_cummins{
  display: flex;
  align-items: center;
  justify-content:center;
  padding-bottom: 20PX;
}

.el-message-box {
  display: inline-block;
  width: 420px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #FFF;
  border-radius: 4px;
  border: 1px solid #EBEEF5;
  font-size: 18px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
/deep/.el-dialog{

  width: 25% !important;
}

//滑动校验部分
/deep/.el-dialog__body{
  padding: none;
}

/deep/.el-dialog__header{
  padding: 0 !important;
}

@media screen and (max-width: 768px) {
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }

}
@media (device-height:480px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone4/4s */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}

@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone5 */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}

@media (device-height:667px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone6 */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}
@media (device-height:736px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone6 Plus */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}


</style>



// WEBPACK FOOTER //
// src/view/index.vue